export default __webpack_public_path__ + "static/media/Empty_screen.41af0250.svg";